// src/views/error.ts
import { html, type TemplateResult } from 'lit-html';

export function renderError(message: string): TemplateResult {
  return html`<div class="container"><h2>出错了 😅</h2><p>${message}</p><a href="#/">回首页</a></div>`;
}
